document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);

  if (params.get('open-cart') === '1') {
    setTimeout(() => {
      document
        .querySelector('[data-testid="cart-drawer-trigger"]')
        ?.click();
    }, 500);
  }
});